export const environment = {
  production: true,
  appUrl: "https://bavox.ch/",
  apiUrl: "https://dev.bavox.ch/api/v1",
  websocket: 'wss://dev.bavox.ch/',
  websocketpath: ''
};